import React, { useState, useContext, useRef, useEffect } from "react";
import {
  Grid,
  TextField,
  InputAdornment,
  Paper,
  IconButton,
  Avatar,
  Button,
  makeStyles,
} from "@material-ui/core";
import { BrowserView, MobileView } from "react-device-detect";
import FlexView from "react-flexview/lib";
import { useForm } from "react-hook-form";
import {
  SessionContextStore,
  SESSION_ACTIONS,
} from "../../../context/SessionContext";
import { OptionalTag } from "../../Core/OptionalTag";
import {
  EventEmitterService,
  EventKey,
} from "../../../services/EventEmitterService";
import "../UserProfile.scss";
import {
  ACTIONS,
  UserProfileContextStore,
} from "../../../context/UserProfileContext";
import { Action } from "../../../models/Action";
import { SessionService } from "../../../services/SessionService";
import { useLocation } from "react-router-dom";
import NewFillButton from "../../Core/NewFillButton";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import DataLayerService from "../../../services/DataLayerService";
const dayjs = require("dayjs");

const useStylesButton = makeStyles((theme) => ({
  root: {
    backgroundColor: "#c7cbcf",
    "&:hover": {
      backgroundColor: "#b1b6bb",
    },
  },
}));

export const CompanySection = (props) => {
  const location = useLocation();
  const context = useContext(UserProfileContextStore);
  const sessionContext = useContext(SessionContextStore);
  const classes = useStylesButton();
  const {
    register,
    watch,
    triggerValidation,
    setValue,
    errors,
    control,
    getValues,
  } = useForm(
    SessionService.isLoggedIn()
      ? {
          defaultValues: {
            company_name: sessionContext.user.company,
          },
          mode: "onChange",
        }
      : { mode: "onChange" }
  );
  const [img, setImg] = useState(sessionContext.user.profilePicture);
  const [imgName, setImgName] = useState("");
  const profilePicture = useRef(null);
  const companyNameWatch = watch("company_name", sessionContext.user.company);
  const uploadProfilePicture = () => profilePicture.current.click();

  const onProfilePictureSelected = async (event) => {
    if (event.target.files.length === 0) return;

    setImg(URL.createObjectURL(event.target.files[0]));
    setImgName(event.target.files[0].name);
    sessionContext.dispatch(
      new Action(
        SESSION_ACTIONS.UPDATE_PROFILE_PICTURE_FILE,
        event.target.files[0]
      )
    );
    DataLayerService.pushToDataLayer({ event: "logo-uploaded" });
  };

  useEffect(() => {
    const id = EventEmitterService.subscribe(
      EventKey.USER_PROFILE_SAVE,
      async () => {
        const valid = await triggerValidation();
        if (valid) {
          context.dispatch(new Action(ACTIONS.SAVE_COMPANY, getValues()));
        }
      }
    );

    return function cleanup() {
      EventEmitterService.unsubscribe(EventKey.USER_PROFILE_SAVE, id);
    };
  }, []);

  useEffect(() => {
    setValue("company_name", sessionContext.user.company);
    setImg(sessionContext.user.profilePicture);
  }, [sessionContext.user]);

  const previewImage = sessionContext.user.profilePicture
    ? sessionContext.user.profilePicture
    : img
    ? img
    : null;

  return (
    <React.Fragment>
      <BrowserView>
        {/* <div className="text-body gray margin-bottom-basic">This name will appear on your certificate of insurance and policy</div> */}
        <Grid container justify="center" spacing={2}>
          <Grid item xs={12} md={6}>
            <FlexView className="margin-top-basic">
              <TextField
                InputLabelProps={{ shrink: !!companyNameWatch }}
                fullWidth
                variant="outlined"
                className="margin-right-basic"
                label="Company name"
                name="company_name"
                inputRef={register}
                error={!!errors.company_name}
              />
            </FlexView>
          </Grid>
          <Grid item xs={12} md={6}>
            <FlexView className="margin-top-basic"></FlexView>
          </Grid>
        </Grid>
      </BrowserView>
      <MobileView>
        <div>
          <TextField
            InputLabelProps={{ shrink: !!companyNameWatch }}
            fullWidth
            variant="outlined"
            className="margin-top-basic margin-bottom-basic"
            label="Company name"
            name="company_name"
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  {" "}
                  <OptionalTag />{" "}
                </InputAdornment>
              ),
            }}
            inputRef={register}
            error={!!errors.company_name}
          />
        </div>
      </MobileView>
      <input
        type="file"
        accept="image/*"
        id="file"
        onChange={onProfilePictureSelected}
        ref={profilePicture}
        style={{ display: "none" }}
      />
    </React.Fragment>
  );
};
